export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "forgot_password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialisez votre mot de passe"])},
          "toggle_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retour à la connexion"])},
          "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valider"])},
          "reset_password_mail_sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si l’adresse email correspond à un compte existant, un email a été envoyé avec un lien de récupération de mot de passe."])}
        },
        "login": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bienvenue sur votre espace abonné!"])},
          "toggle_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe oublié ?"])},
          "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])}
        },
        "email_address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse email"])},
        "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe"])},
        "credentials_invalid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'adresse email ou le mot de passe est incorrect"])},
        "email_invalid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'adresse email est invalide."])},
        "email_required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'adresse email est obligatoire."])}
      },
      "en": {
        
      }
    }
  })
}
